module.exports = {
    "baseUrl": "https://api-v4.primrose.health",
    "systemName": "System Prod",
    "favicon": "%PUBLIC_URL%/favicon.png",
    "companyTitle": "Payment Portal | Trillium Health",
    "companyKey": "trillium",
    "website": "https://trillium.health/",
    "cdnUrl": "https://cdn.primrose.health",
    "companyName": "Trillium Technologies",
    "copyRight": "Primrose Health and Trillium Technologies are trademarks of their respective owners.",
    "phoneNumber": "(972) 432-4976",
    "isChatBotEnabled": false
}